import { AuthGuard } from '@/modules/auth/router/auth.guard';
import { OrganisationGuard } from '@/modules/auth/router/organisation.guard';
import multiguard from 'vue-router-multiguard';

export default [
    {
        name: 'assets',
        path: '/assets',
        component: () => import(/* webpackChunkName: "asset" */ '@/modules/asset/views/Assets.vue'),
        meta: { title: 'Assets' },
        beforeEnter: multiguard([AuthGuard, OrganisationGuard]),
    },
    {
        name: 'assets:view',
        path: '/assets/:id',
        component: () => import(/* webpackChunkName: "asset" */ '@/modules/asset/views/ViewAsset.vue'),
        meta: { title: 'View Asset' },
        props: true,
        beforeEnter: multiguard([AuthGuard, OrganisationGuard]),
    },
    {
        name: 'assets:edit',
        path: '/assets/:id/edit',
        component: () => import(/* webpackChunkName: "asset" */ '@/modules/asset/views/EditAsset.vue'),
        meta: { title: 'Edit Asset' },
        props: true,
        beforeEnter: multiguard([AuthGuard, OrganisationGuard]),
    },
];
